import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type QuickCardEditorBoardFragment = (
  { __typename: 'Board' }
  & Pick<Types.Board, 'id'>
  & { prefs?: Types.Maybe<(
    { __typename: 'Board_Prefs' }
    & Pick<Types.Board_Prefs, 'isTemplate'>
  )> }
);

export const QuickCardEditorBoardFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'QuickCardEditorBoard' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Board' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prefs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isTemplate' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseQuickCardEditorBoardFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      QuickCardEditorBoardFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseQuickCardEditorBoardFragmentResult
  extends Omit<Apollo.UseFragmentResult<QuickCardEditorBoardFragment>, 'data'> {
  data?: QuickCardEditorBoardFragment;
}

export const useQuickCardEditorBoardFragment = ({
  from,
  returnPartialData,
  ...options
}: UseQuickCardEditorBoardFragmentOptions): UseQuickCardEditorBoardFragmentResult => {
  const result = Apollo.useFragment<QuickCardEditorBoardFragment>({
    ...options,
    fragment: QuickCardEditorBoardFragmentDoc,
    fragmentName: 'QuickCardEditorBoard',
    from: {
      __typename: 'Board',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as QuickCardEditorBoardFragment };
};
